import { Value } from '@sinclair/typebox/value';
import { AgentStreamMessage } from './envelope.js';
import { HistoryPage } from './history.js';
import { AgentSessionResponse, ClientMessage, CommandAcknowledgementMessage, CreateAgentRequest, IncompatibleProtocolVersionErrorMessage, ProviderListResponse, ResumeAgentRequest, ServerMessage, } from './messages.js';
import { ResourceResponse, ResourceUpdate, } from './resources.js';
import { AgentSnapshot } from './snapshot.js';
import { BORGEE_AGENT_REMOTE_PROTOCOL_VERSION } from './version.js';
function shapeIssues(schema, value) {
    return [...Value.Errors(schema, value)].map((error) => ({
        code: 'invalid_shape',
        path: error.path,
        message: error.message,
    }));
}
function versionIssues(value) {
    if (value.protocolVersion === BORGEE_AGENT_REMOTE_PROTOCOL_VERSION)
        return [];
    return [{
            code: 'incompatible_protocol_version',
            path: '/protocolVersion',
            message: `Protocol version ${value.protocolVersion} is incompatible with ${BORGEE_AGENT_REMOTE_PROTOCOL_VERSION}.`,
        }];
}
function decode(json, schema) {
    let value;
    try {
        value = JSON.parse(json);
    }
    catch {
        return { status: 'rejected', issues: [{ code: 'invalid_json', path: '', message: 'Invalid JSON.' }] };
    }
    if (typeof value === 'object'
        && value !== null
        && 'protocolVersion' in value
        && typeof value.protocolVersion === 'string') {
        const issues = versionIssues(value);
        if (issues.length > 0)
            return { status: 'rejected', issues };
    }
    if (!Value.Check(schema, value))
        return { status: 'rejected', issues: shapeIssues(schema, value) };
    const typed = value;
    const issues = versionIssues(typed);
    return issues.length > 0 ? { status: 'rejected', issues } : { status: 'ok', value: typed };
}
function decodeShape(json, schema) {
    let value;
    try {
        value = JSON.parse(json);
    }
    catch {
        return { status: 'rejected', issues: [{ code: 'invalid_json', path: '', message: 'Invalid JSON.' }] };
    }
    if (!Value.Check(schema, value))
        return { status: 'rejected', issues: shapeIssues(schema, value) };
    return { status: 'ok', value: value };
}
function encode(value, schema) {
    const issues = versionIssues(value);
    if (issues.length > 0)
        return { status: 'rejected', issues };
    if (!Value.Check(schema, value))
        return { status: 'rejected', issues: shapeIssues(schema, value) };
    try {
        return { status: 'ok', json: JSON.stringify(value) };
    }
    catch {
        return {
            status: 'rejected',
            issues: [{ code: 'not_json_serializable', path: '', message: 'Value cannot be serialized as JSON.' }],
        };
    }
}
export function decodeAgentSnapshot(json) {
    return decode(json, AgentSnapshot);
}
export function encodeAgentSnapshot(value) {
    return encode(value, AgentSnapshot);
}
export function decodeHistoryPage(json) {
    return decode(json, HistoryPage);
}
export function encodeHistoryPage(value) {
    return encode(value, HistoryPage);
}
export function decodeAgentStreamMessage(json) {
    return decode(json, AgentStreamMessage);
}
export function encodeAgentStreamMessage(value) {
    return encode(value, AgentStreamMessage);
}
export function decodeResourceResponse(json) {
    return decode(json, ResourceResponse);
}
export function encodeResourceResponse(value) {
    return encode(value, ResourceResponse);
}
export function decodeResourceUpdate(json) {
    return decode(json, ResourceUpdate);
}
export function encodeResourceUpdate(value) {
    return encode(value, ResourceUpdate);
}
export function decodeCreateAgentRequest(json) {
    return decode(json, CreateAgentRequest);
}
export function encodeCreateAgentRequest(value) {
    return encode(value, CreateAgentRequest);
}
export function decodeResumeAgentRequest(json) {
    return decode(json, ResumeAgentRequest);
}
export function encodeResumeAgentRequest(value) {
    return encode(value, ResumeAgentRequest);
}
export function decodeAgentSessionResponse(json) {
    return decode(json, AgentSessionResponse);
}
export function encodeAgentSessionResponse(value) {
    return encode(value, AgentSessionResponse);
}
export function decodeProviderListResponse(json) {
    return decode(json, ProviderListResponse);
}
export function encodeProviderListResponse(value) {
    return encode(value, ProviderListResponse);
}
export function decodeCommandAcknowledgementMessage(json) {
    return decode(json, CommandAcknowledgementMessage);
}
export function encodeCommandAcknowledgementMessage(value) {
    return encode(value, CommandAcknowledgementMessage);
}
export function decodeClientMessage(json) {
    return decode(json, ClientMessage);
}
export function encodeClientMessage(value) {
    return encode(value, ClientMessage);
}
export function decodeServerMessage(json) {
    return decode(json, ServerMessage);
}
export function decodeIncompatibleProtocolVersionError(json) {
    return decodeShape(json, IncompatibleProtocolVersionErrorMessage);
}
export function encodeServerMessage(value) {
    return encode(value, ServerMessage);
}
//# sourceMappingURL=codec.js.map